import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'
import { unboundedWire } from '~/services/api/contracts/unboundedWire'
import { CustomizationGroupStatusSchema, SelectionTypeSchema } from '~/services/api/generated'

export const customizationGroupFieldsNormalizer = fieldNormalizer({
  trimmed: ['name'],
  enums: [
    { field: 'status', options: CustomizationGroupStatusSchema.options },
    { field: 'selection_type', options: SelectionTypeSchema.options }
  ],
  custom: [
    { keys: ['max_per_option', 'max_total_selections'], apply: unboundedWire, skipNull: true }
  ]
})
